import { useFormikContext } from "formik";
import React, { useState } from "react";
import { useRouteLoaderData } from "react-router-dom";
import { findField, updateField } from "@app/utils/form"

export const useCustomerObserver = (currentFieldsets) => {
	const { values, setValues } = useFormikContext();
	const { office } = useRouteLoaderData("root");
	const customerId = values.kundenundeinsatzort_kunde_kunde__ID;
	const [prevCustomer, setPrevCustomer] = useState(values.kundenundeinsatzort_kunde_kunde__ID);
	const field_adressetyp = findField(currentFieldsets, 'kundenundeinsatzort_einsatzort_adressetyp')

	const res = React.useMemo(() => {
		if (customerId && field_adressetyp) {
			const currentCustomer = office?.kundenliste.find(
				({ KundenName, KUNDENNR }) => {
					return KUNDENNR.toString() === customerId.toString();
				},
			);

			let newFieldsets = updateField(currentFieldsets, "kundenundeinsatzort_einsatzort_adressetyp", (element) => {
				return {
					...element,
					options: [
						...element.options.slice(0, 3),
						...(currentCustomer?.EinsatzAdressen || []).map(({ EinsatzAdresse_ID, Adresse }) => ({
							label: Adresse,
							value: Adresse,
							selected: false,
						})),
					],
				};
			});

			if (currentCustomer?.Ansprechpartner) {
				newFieldsets = updateField(
					newFieldsets,
					"kundenundeinsatzort_wichtigeperson_ansprechpartner",
					(element) => {
						return {
							...element,
							options: [
								...(currentCustomer?.Ansprechpartner || []).map(
									({ Ansprech_ID, Anrede, Nachname }) => ({
										label: `${Anrede} ${Nachname}`,
										value: `${Anrede} ${Nachname}`,
										//value: Ansprech_ID,
										selected: false,
									}),
								),
								...element.options.filter((item) => item.value === "Neuer Ansprechpartner"),
							],
						};
					},
				);
			}

			// reset dependent fields, when customer has changed
			if (prevCustomer !== customerId) {
				const [streetAndNr, postCode, city] =
					currentCustomer && currentCustomer.KundenAdresse
						? currentCustomer.KundenAdresse.split(",").map((x) => x.trim())
						: [];
				const customerAddress = currentCustomer?.KundenAdresse
					? {
						kundenundeinsatzort_kunde_strasseundhausnummer: streetAndNr,
						kundenundeinsatzort_kunde_plz: postCode,
						kundenundeinsatzort_kunde_ort: city,
					}
					: {
						kundenundeinsatzort_kunde_strasseundhausnummer: "",
						kundenundeinsatzort_kunde_plz: "",
						kundenundeinsatzort_kunde_ort: "",
					};

				setValues({
					...values,
					kundenundeinsatzort_wichtigeperson_ansprechpartner: "",
					kundenundeinsatzort_wichtigeperson_ansprechpartnerfreitext: "",
					kundenundeinsatzort_einsatzort_bezeichnungdesplatzes: "",
					kundenundeinsatzort_einsatzort_adressetyp: "",
					kundenundeinsatzort_einsatzort_arbeitsbereich: "",
					kundenundeinsatzort_einsatzort_folgebesichtigung: "",
					kundenundeinsatzort_einsatzort_ort: "",
					kundenundeinsatzort_einsatzort_plz: "",
					kundenundeinsatzort_einsatzort_strasseundhausnummer: "",
					...customerAddress,
				});
				setPrevCustomer(customerId);
			}

			// setCurrentFieldsets(newFieldsets);
			return {
				fieldsets: newFieldsets
			}
		}
		return {
			fieldsets: currentFieldsets
		}
	}, [customerId, field_adressetyp?.name, currentFieldsets]);

	return res;
};

const CustomerObserver = ({ currentFieldsets, setCurrentFieldsets }) => {
	const {fieldsets} = useCustomerObserver(currentFieldsets)
	setCurrentFieldsets(fieldsets);
	return null;
}

export default CustomerObserver;
